import { autoserialize } from 'cerialize';

export class LoginCredentials {
  @autoserialize
  username: string;

  @autoserialize
  password: string;

  constructor(username: string, password: string) {
    this.username = username;
    this.password = password;
  }
}
